<span class="customFieldDescriptionIcon">
  <pp-icon
    ppTooltip
    [ppTitle]="ppDescription()"
    [ppSrc]="EIconPath.ICON_MISC_INFO"
    ppColor="inherit"
    ppClass="setSize14"
  />
</span>
